<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <div class="text-danger" v-show="!this.validationIsValid">
                        Order number and vehicle registration could not be verified please ensure that the details are correct and try again
                    </div>
                    <fuel-dispensement-validation
                            :collectionCode="codeForCollection"
                            :vehicleRegistration="vehicleRegistration"
                            @validationCompleted="onValidationComplete" v-if="!canMoveOnToNextStep"></fuel-dispensement-validation>
                    <dispense-fuel-form
                            :orderNumber="orderNumber"
                            :vehicleRegistration="vehicleRegistration"
                            :orderCollection="orderForCollection"
                            :orderItems="orderItems"
                            @dispensementCompleted="onDispensementCompleted"
                            v-if="canMoveOnToNextStep"></dispense-fuel-form>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
</div>
